<script lang="ts">
  import sprite from '../images/sprite-sheet.svg';

  export let icon: string = 'placeholder';
  export let color: string = '#FF1A66';
  export let width: number = 40;
  export let height: number = 40;
</script>

<svg {width} {height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <use href="{sprite}#{icon}" stroke={color} fill={color} x="0" y="0" width="24" height="24" />
</svg>
